import { SimpleFetchTransport } from "./fetch.js";
class ProxyTransport extends SimpleFetchTransport {
  constructor(config) {
    super({
      input: config.url,
      autoFlush: config.autoFlush,
      logLevel: config.logLevel
    });
  }
}
export {
  ProxyTransport
};
//# sourceMappingURL=proxy-transport.js.map
